var defaultProps = {
  containerProps: {},
  onChange: function onChange() {
    return null;
  },
  orientation: 'vertical',
  disabled: false,
  truncateText: false,
  labelProps: {
    feedbackMessage: '',
    labelText: '',
    required: false
  }
};

export { defaultProps };
//# sourceMappingURL=defaultProps.js.map
